import { Box, Button, useTheme } from '@material-ui/core';
import { CSSProperties, Children, FC, ReactNode } from 'react';
import { WbSearch } from '../WbSearch';

interface CommonProps {
  children?: ReactNode;
  onClear?: () => void;
  clearButtonText?: string;
  style?: CSSProperties;
}

type ConditionalProps =
  | {
      onSearch: (value: string) => void | undefined;
      searchValue: string | undefined;
    }
  | {
      onSearch?: never;
      searchValue?: never;
    };

type Props = CommonProps & ConditionalProps;

export const WbTableFilters: FC<Props> = ({
  children,
  onClear,
  clearButtonText,
  searchValue,
  onSearch,
  style,
}) => {
  const theme = useTheme();
  return (
    <Box
      style={{
        display: 'flex',
        // flexWrap: 'wrap',
        marginBottom: theme.spacing(2),
        ...style,
      }}
    >
      <Box
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          columnGap: theme.spacing(1.5),
          rowGap: theme.spacing(0.75),
          alignItems: 'center',
          width: '100%',
        }}
      >
        {onSearch && (
          <WbSearch
            fullWidth={false}
            value={searchValue}
            onChange={onSearch}
            debounced
            style={{
              height: '36px',
            }}
          />
        )}

        {children}
      </Box>

      {onClear && Children.count(children) > 0 && (
        <Box
          style={{
            flex: 1,
            // height equal to an EnumFilter so that the button is centered in respect to the first row only
            height: '36px',
            minWidth: '100px',
            marginLeft: '20px',
            justifyContent: 'flex-end',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {onClear && (
            <Button
              variant="outlined"
              size="small"
              color="primary"
              onClick={onClear}
            >
              {clearButtonText ? clearButtonText : 'Clear filters'}
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};
